export const PAGE_SIZE_OPTIONS = [10, 25, 50] as const;
export const DEFAULT_PAGE_SIZE = 10;

const STORAGE_KEY = "tablePageSize";

export const getStoredPageSize = (): number => {
  try {
    const stored = Number(localStorage.getItem(STORAGE_KEY));
    return (PAGE_SIZE_OPTIONS as readonly number[]).includes(stored)
      ? stored
      : DEFAULT_PAGE_SIZE;
  } catch {
    return DEFAULT_PAGE_SIZE;
  }
};

export const storePageSize = (pageSize: number) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(pageSize));
  } catch {
    return;
  }
};
